/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Box, Heading, Text } from '@chakra-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { Cell } from 'react-table';
import { FormattedTodo } from '../../types';
import colors from '../../../../styles/colors';

interface LocationProps {
  cellData: Cell<FormattedTodo, any>;
}

export const LocationCell = React.memo(function Location({ cellData }: LocationProps) {
  const { row, column, value } = cellData;
  const { customName, position, candidateId } = row.original;

  return (
    <Link
      to={{
        pathname: `/positionCandidates/${position}/messaging`,
        state: {
          redirectedFromPage: 'RecruiterTodoListTableView',
          selectedCandidateId: candidateId,
          locationToPushOnBack: '/dashboard',
        },
      }}
    >
      <Box className={column.id} data-testid={column.id}>
        <Text fontSize="sm" color="gray.600" lineHeight="1.2">
          {value}
        </Text>
        <Heading fontSize="16px" color={colors.linkBlue} mb={1} lineHeight="1.2" as="span" textDecoration="underline">
          {customName}
        </Heading>
      </Box>
    </Link>
  );
});
